import { render, staticRenderFns } from "./Dev.vue?vue&type=template&id=f59b2502&scoped=true&"
import script from "./Dev.vue?vue&type=script&lang=js&"
export * from "./Dev.vue?vue&type=script&lang=js&"
import style0 from "./Dev.vue?vue&type=style&index=0&id=f59b2502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59b2502",
  null
  
)

export default component.exports